<template>
	<div>
		<div class="title">
			<div class="header">
				<div class="header_title-container title">
					<h1>{{ $t("subscriptions") }}</h1>
				</div>

				<div class="header_actions">
					<div class="header_actions-container">
						<option-button
							:show="true"
							:buttons="buttons"
							@clear="selecteds = []"
							@archive="() => doMutate({ element: 'deleting', value: true })"
							@restore="() => doMutate({ element: 'restoring', value: true })"
							@add="add = true"
							@close="add = false"
							:csvEntity="'subscriptions'"
							:csvHeader="csvHeader"
							:csvFilters="getFilters"
							:processCsv="processCsv"
						/>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex; width: 100%; margin-bottom: 10px">
			<el-input
				v-model="filters_text"
				style="width: 40%"
				:placeholder="$t('search-something')"
				clearable
				@keyup.enter.native="handleSearch(false)"
			/>
			<el-select
				style="width: 60%"
				:placeholder="$t('level')"
				v-model="filters_options"
				multiple
				value-key="level"
				:collapse-tags="filters_options.length > 4"
			>
				<el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label" />
			</el-select>
			<el-button
				icon="el-icon-search"
				type="primary"
				@click="e => handleSearch(false)"
				style="width: 75px; margin-left: auto; margin-right: 0"
			/>
			<el-button
				v-if="searching"
				type="warning"
				@click="e => handleSearch(true)"
				style="width: 75px; margin-left: auto; margin-right: 0"
				icon="el-icon-close"
			/>
		</div>

		<div v-if="subscriptions.array" style="display: flex">
			<app-deleted-items :deleted_at="deleted_at" @change="v => (deleted_at = v)" />
			<app-total
				:start="pagination.offset"
				:end="pagination.offset + subscriptions.array.length"
				:total="subscriptions.count"
			/>
		</div>

		<div>
			<div :style="{ height: height + 'px' }" v-loading="loading" style="overflow-y: auto">
				<md-table v-model="subscriptions.array">
					<md-table-row
						slot="md-table-row"
						slot-scope="{ item }"
						md-selectable="single"
						@click="() => rowClick(item)"
					>
						<md-table-cell width="50">
							<md-checkbox
								:id="item.id"
								v-model="selecteds"
								:value="item"
								@click="e => e.stopPropagation()"
							></md-checkbox>
						</md-table-cell>
						<md-table-cell :md-label="$t('name').toUpperCase()">{{ item.name }}</md-table-cell>
						<md-table-cell :md-label="$t('area').toUpperCase()">
							<el-tag v-for="area in item.areas" :key="area.id">
								{{ area.name }}
							</el-tag>
						</md-table-cell>
						<md-table-cell width="125" :md-label="$t('duration-month').toUpperCase()">
							<span>{{ item.duration_month }}{{ " " + $t("month") }}</span>
						</md-table-cell>
						<md-table-cell width="150" :md-label="$t('price').toUpperCase()">{{
							"€ " + item.price.toFixed(2)
						}}</md-table-cell>
						<md-table-cell width="200" :md-label="$t('ticketing-service').toUpperCase()">
							<span v-if="item.ticketing">{{ $t("with-ticketing-service") }}</span>
							<span v-else>{{ $t("without-ticketing-service") }}</span>
						</md-table-cell>
						<md-table-cell width="100" :md-label="$t('visible').toUpperCase()">
							<el-tag v-if="item.visible" effect="dark" type="success">{{ $t("visible") }}</el-tag>
							<el-tag v-else effect="dark" type="danger">{{ $t("invisible") }}</el-tag>
						</md-table-cell>
						<md-table-cell v-if="deleted_at" :md-label="$t('deleted-at').toUpperCase()">
							<span>{{
								item.deleted_at ? moment(item.deleted_at).format("DD/MM/YYYY HH:mm:ss") : ""
							}}</span>
						</md-table-cell>
						<md-table-cell width="25">
							<option-table-button
								placement="bottom"
								:buttons="getTableActions(item)"
								@delete="
									() => {
										doMutate({ element: 'deleting', value: true })
										selected = item
									}
								"
								@restore="
									() => {
										doMutate({ element: 'restoring', value: true })
										selected = item
									}
								"
							/>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>

			<app-pagination
				:tot="subscriptions.count"
				:size="pagination.size"
				:offset="pagination.offset"
				@fetch="(a, b) => doFetch(a, b)"
			/>
		</div>

		<subscriptions-add :show="add" @close="add = false" @add="add = true" />

		<delete-confirm-modal :show="view_modal" :title="title" :content="content" @close="handleFunction" />
	</div>
</template>

<script>
import moment from "moment"
import axios from "axios"
import { mapGetters, mapActions } from "vuex"
import OptionTableButton from "@/modules/_common/button/option-table-button.vue"
import AppPagination from "@/modules/_common/table/app-pagination.vue"
import AddButton from "@/modules/_common/button/add-button.vue"
import OptionButton from "@/modules/_common/button/option-button.vue"
import AppTotal from "@/modules/_common/table/app-total.vue"
import DeletedItems from "@/modules/_common/table/app-deleted-items.vue"
import DeleteConfirmModal from "@/modules/_common/modal/delete-confirm-modal.vue"

import SubscriptionsAdd from "@/modules/datas/subscriptions/subscriptions-components/subscriptions-add.vue"
import SubscriptionsOptions from "@/modules/datas/subscriptions/subscriptions-components/subscriptions-options.vue"

export default {
	name: "subscriptions-list",
	components: {
		OptionTableButton,
		AppPagination,
		AddButton,
		OptionButton,
		SubscriptionsAdd,
		SubscriptionsOptions,
		AppTotal,
		"app-deleted-items": DeletedItems,
		DeleteConfirmModal
	},
	data() {
		return {
			height: window.innerHeight - 320,
			selecteds: [],
			buttons: ["add", "option", "option-csv"],
			loading: false,
			searching: false,

			options: [
				{
					value: "visible",
					label: this.$t("visible")
				},
				{
					value: "ticketing",
					label: this.$t("yes-ticketing")
				},
				{
					value: "invisible",
					label: this.$t("invisible")
				},
				{
					value: "not-ticketing",
					label: this.$t("not-ticketing")
				}
			],
			filters_text: "",
			filters_options: ["visible", "ticketing", "invisible", "not-ticketing"],

			deleted_at: false,

			// SINGLE ELEMENT DETAILS
			show_details: false,
			selected: undefined,
			show_options: false,

			add: false,

			//CSV
			csvHeader: [
				this.$t("id"),
				this.$t("name"),
				this.$t("duration-month"),
				this.$t("price"),
				this.$t("currency"),
				this.$t("ticketing-service"),
				this.$t("visible"),
				this.$t("areas"),
				this.$t("created-at"),
				this.$t("updated-at"),
				this.$t("deleted-at")
			]
		}
	},
	computed: {
		...mapGetters({
			deleting: "subscription/deleting",
			restoring: "subscription/restoring",
			subscriptions: "subscription/subscriptions",
			pagination: "subscription/pagination"
		}),
		view_modal: function () {
			return this.deleting || this.restoring
		},
		title: function () {
			if (this.deleting) return this.$t("deleting-subscriptions-modal-title")
			else if (this.restoring) return this.$t("restoring-subscriptions-modal-title")
		},
		content: function () {
			if (this.deleting) return this.$t("deleting-subscriptions-modal-content")
			else if (this.restoring) return this.$t("restoring-subscriptions-modal-content")
		}
	},
	watch: {
		selecteds: function () {
			if (this.selecteds.length > 0) {
				if (this.selecteds.every(el => el.deleted_at != undefined)) this.buttons = ["clear", "restore"]
				else this.buttons = ["clear", "archive"]
			} else {
				this.buttons = ["add", "option", "option-csv"]
			}
		},
		deleted_at: function () {
			this.doFetch(1, this.pagination.size)
		},
		selected: function () {
			if (this.selected == undefined) this.show_details = false
		},
		show_details: function () {
			if (!this.show_details) {
				if (this.deleting) this.doMutate({ element: "deleting", value: false })
				if (this.restoring) this.doMutate({ element: "restoring", value: false })
			}
		},
		view_modal: function () {
			if (!this.view_modal) {
				this.selecteds = []
				this.selected = undefined
			}
		}
	},

	created() {
		if (this.$route.params.id) {
			var r = this.getById(this.$route.params.id)
			r.then(result => this.rowClick(result))
		}
		this.doFetch(1, this.pagination.size)
	},

	methods: {
		moment,
		...mapActions({
			doMutate: "subscription/doMutate",
			getById: "subscription/getById",
			doGetList: "subscription/getList",
			doDelete: "subscription/doDelete",
			doRestore: "subscription/doRestore"
		}),
		getTableActions: function (item) {
			var r = []
			if (item.deleted_at != undefined) r.push("restore")
			else r.push("delete")

			return r
		},
		rowClick: function (item) {
			this.doMutate({ element: "subscription", value: item })
			this.$router.push({ path: "/datas/subscriptions/" + item.id })
		},

		handleFunction: function (value) {
			if (!value) {
				if (this.deleting) this.doMutate({ element: "deleting", value: false })
				if (this.restoring) this.doMutate({ element: "restoring", value: false })

				return
			} else {
				if (this.deleting) this.handleDelete()
				else if (this.restoring) this.handleRestore()
			}
		},

		handleDelete: function () {
			var array = []
			this.selecteds.forEach(item => {
				if (item.deleted_at == undefined) array.push(item)
			})
			if (this.selecteds.length == 0 && this.selected != undefined) array.push(this.selected)
			if (array.length == 0) {
				this.doMutate({ element: "deleting", value: false })
				return
			}
			this.delete(array)
		},
		async delete(payload) {
			var result = await this.doDelete(payload)
			if (result.status) {
				for (var i = 0; i < this.subscriptions.array.length; i++) {
					var deleted = result.value.deleted && result.value.deleted.includes(this.subscriptions.array[i].id)
					var soft_deleted =
						result.value.soft_deleted && result.value.soft_deleted.includes(this.subscriptions.array[i].id)

					if (this.deleted_at && soft_deleted) {
						this.subscriptions.array[i].deleted_at = new Date()
					} else {
						if (deleted || soft_deleted) {
							this.subscriptions.array.splice(i, 1)
							this.subscriptions.count -= 1
							i--
						}
					}
				}
				this.doMutate({
					element: "subscriptions",
					value: { array: this.subscriptions.array, count: this.subscriptions.count }
				})
				this.$notification("success", this.$t("deleted-successfully"), "", 4000)
			} else {
				this.$processError(this.$t("delete-error"), result.value)
			}
			this.doMutate({ element: "deleting", value: false })
		},

		handleRestore: function () {
			var ids = []
			this.selecteds.forEach(item => {
				if (item.deleted_at != undefined) ids.push(item.id)
			})
			if (this.selected && this.selected.deleted_at != undefined) ids.push(this.selected.id)

			if (ids.length == 0) {
				this.doMutate({ element: "restoring", value: false })
				return
			}

			this.restore(ids)
		},

		async restore(payload) {
			var result = await this.doRestore(payload)
			if (result.status) {
				this.$notification("success", this.$t("restored-successfully"), "", 4000)
				if (this.selected) this.selecteds.push(this.selected)
				this.selecteds.forEach(item => {
					var i = this.subscriptions.array.indexOf(item)
					if (!this.deleted_at) {
						this.subscriptions.array.splice(i, 1)
						this.subscriptions.count -= 1
					} else {
						this.subscriptions.array[i].deleted_at = undefined
					}
				})
			} else {
				this.$processError(this.$t("restore-error"), status.msg)
			}

			this.doMutate({ element: "restoring", value: false })
		},

		handleSearch: function (reset) {
			this.searching = !reset
			if (!this.searching) {
				this.filters_text = ""
				this.filters_options = []
				this.options.forEach(item => this.filters_options.push(item.value))
			}
			this.doFetch(1, this.pagination.size)
		},

		getFilters(withFilters, page = undefined, size = undefined) {
			if (!withFilters)
				return {
					name: "",
					deleted_at: true,
					visible: true,
					ticketing: true,
					invisible: true,
					"not-ticketing": true
				}

			if (size && page) {
				this.pagination.size = size
				this.pagination.offset = (page - 1) * this.pagination.size
			}

			var filters = {
				name: this.filters_text ? this.filters_text : "",
				deleted_at: this.deleted_at
			}

			if (size && page) {
				filters.offset = this.pagination.offset
				filters.size = this.pagination.size
			}

			this.options.forEach(element => {
				let check = this.filters_options.includes(element.value)
				if (check) {
					filters[element.value] = true
				} else {
					filters[element.value] = false
				}
			})

			return filters
		},

		doFetch: function (page, size) {
			var filters = this.getFilters(true, page, size)
			this.doMutate({ element: "pagination", value: { offset: filters.offset, size: filters.size } })
			this.loading = true
			this.getList(filters)
		},

		async getList(filters) {
			await this.doGetList(filters)
			this.loading = false
		},

		processCsv: function (item) {
			var data = []
			var areas = []
			item.areas.forEach(el => {
				areas.push(el.name.replace(/"/g, '""'))
			})
			areas = areas.join(", ")

			data.push("id: " + item.id)
			data.push('"' + item.name.replace(/"/g, '""') + '"')
			data.push(item.duration_month)
			data.push(item.price.toFixed(2))
			data.push(item.currency)
			data.push(item.ticketing ? "Sì" : "No")
			data.push(item.visible ? "Sì" : "No")
			data.push('"' + areas + '"')
			data.push(moment(item.created_at).format("DD/MM/YYYY HH:mm:ss"))
			data.push(item.updated_at ? moment(item.updated_at).format("DD/MM/YYYY HH:mm:ss") : "-")
			data.push(item.deleted_at ? moment(item.deleted_at).format("DD/MM/YYYY HH:mm:ss") : "-")

			return data
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-tab.scss";
@import "src/assets/scss/my-menu";
@import "src/assets/scss/documents.scss";
</style>
